import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
export function DiscoveryCall() {
  return <section id="agendar" className="py-14 md:py-20 bg-brand-sage-light/40" data-id="element-76">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-77">
        <FadeIn data-id="element-78">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-brand-ink mb-8 leading-tight" data-id="element-79">
            ¿Quieres mirar tu caso conmigo?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-80">
          <div className="space-y-5 font-sans text-lg text-brand-ink/80 leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-81">
            <p data-id="element-82">
              Si al ver la masterclass sentiste que esto habla de ti, puedes
              agendar una llamada de descubrimiento de 15 a 30 minutos.
            </p>
            <p data-id="element-83">
              En esta conversación exploraremos qué estás atravesando, qué
              patrones podrían estar repitiéndose y si una sesión 1:1 conmigo es
              el siguiente paso adecuado para ti.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-84">
          <Button href="https://api.leadconnectorhq.com/widget/booking/kiMwaUwzHpX0z6UxKbPj" variant="primary" data-id="element-85">
            Agendar mi llamada
          </Button>
        </FadeIn>
      </div>
    </section>;
}